import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from ".././../constants/Global";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import DataService from ".././../services/tutorial.service";
import Demo from "../crop/Demo";
import { joinAuction, playerlistData } from "../../actions/index";
import { Image, Shimmer } from "react-shimmer";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import $ from "jquery";
import ImageCropper1 from "../cropper/ImageCropper";
import ImageCropper2 from "../utils/Demo";
import { playerdefaultLogo } from "../../constants/Images";
import { bat, qr1 } from "../../constants/Images";
import { ball } from "../../constants/Images";
import { wkeeper } from "../../constants/Images";
import * as AiIcons from "react-icons/ai";
import styled from "styled-components";
import { Copy, Check } from "lucide-react";
import ExternalDataService from "../../services/external.service";
// Styled components for QR payment section
const QRContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  background-color: #f9f9f9;
`;

const QRImageWrapper = styled.div`
  text-align: left;
  margin-right: 20px;
`;

const QRImage = styled.img`
  width: 130px;
  height: 130px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 5px;
  background-color: white;
`;

const QRDetailsWrapper = styled.div`
  flex: 1;
  text-align: left;
`;

const QRSectionTitle = styled.h4`
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
`;

const QRDetailRow = styled.div`
  margin-bottom: 8px;
`;

const QRDetailLabel = styled.label`
  font-weight: bold;
  color: #555;
  display: inline-block;
  width: 100px;
`;

const QRDetailValue = styled.span`
  color: #333;
`;

const QRFeeValue = styled.span`
  color: #e53e3e;
  font-weight: bold;
`;

const QRInstructions = styled.div`
  margin-top: 15px;
  font-size: 13px;
  color: #666;
`;

// File Upload Styling
const fileUploadStyles = `
  .receipt-label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #333;
  }
  
  .required-asterisk {
    color: red;
  }
  
  .file-upload-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    border: 2px dashed #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
    transition: all 0.3s ease;
  }
  
  .file-upload-container:hover {
    border-color: #999;
    background-color: #f0f0f0;
  }
  
  .upload-icon {
    margin-bottom: 10px;
    color: #666;
  }
  
  .upload-text {
    margin: 0 0 10px 0;
    font-size: 14px;
    color: #666;
    text-align: center;
  }
  
  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  
  .error-message {
    color: red;
    font-size: 12px;
    margin-top: 5px;
  }
  
  .file-size-limit {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    font-style: italic;
    text-align: center;
  }
`;

function JoinAuctionPage(match) {
  const dispatch = useDispatch();
  const getpageData = useSelector((state) => state.setJoinAuction);
  const [iscopied3, setIscopied3] = useState(false);
  const [iscopied4, setIscopied4] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const loginuser = useSelector((state) => state.setUserlog);
  const {
    register: registerCode,
    handleSubmit: handleSubmitCode,
    reset,
    formState: { errors: errorsCode },
  } = useForm();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const formlinkcopy3 = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setIscopied3(true);
      setTimeout(() => setIscopied3(false), 1000);
    } catch (err) {
      console.error("Copy failed:", err);
      alert("Copy failed! Please select and copy manually.");
    }
  };
  const formlinkcopy4 = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setIscopied4(true);
      setTimeout(() => setIscopied4(false), 1000);
    } catch (err) {
      console.error("Copy failed:", err);
      alert("Copy failed! Please select and copy manually.");
    }
  };
  // Move all useState hooks to the top level
  const [othersp3, setOthersp3] = useState(false);
  const [sp3, setsp3] = useState("");
  const [isDisabled, setDisabled] = useState(false);
  const [batting, setBatting] = useState("none");
  const [otherBatting, setOtherBatting] = useState(0);
  const [otherBowling, setOtherBowling] = useState(0);
  const [bowling, setBowling] = useState(0);
  const [cid, setCid] = useState(loginuser?.cid || "");
  const [catData, setcatData] = useState([]);
  const [isjoinanother, setisjoinanother] = useState(false);
  const [catid, setcatid] = useState("");
  const [isbat, setisbat] = useState(false);
  const [isbol, setisbol] = useState(false);
  const [iswkeep, setiswkeep] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");
  const [defimg, setdefimg] = useState(playerdefaultLogo);
  const [defimg2, setdefimg2] = useState("");
  const [helpline, sethelpline] = useState("");
  const [selectedReceiptFile, setSelectedReceiptFile] = useState(null);
  const [pyqr, setpyqr] = useState(null);
  const [paymentData, setPaymentData] = useState(null);
  const [date, setDate] = useState(null);
  const [savedFilename, setSavedFilename] = useState(defimg2 || "");


  // Initialize state with default values or derived from props
  const auctionType = getpageData?.response?.data?.detail?.acttype || "0";
  const [auctype, setauctype] = useState(auctionType);

  const [sp1opt] = useState([
    "All Rounder",
    "Batting All Rounder",
    "Bowling All Rounder",
    "All Rounder Wicketkeeper",
    "Batsman",
    "Bowler",
    "Wicket Keeper",
    "Batter",
    "Other",
  ]);

  const [sp2opt] = useState([
    "Right Hand",
    "Left Hand",
    "Right Hand Batsman",
    "Left Hand Batsman",
    "Right Hand Opener",
    "Left Hand Opener",
    "Right Hand Middle Order",
    "Left Hand Middle Order",
  ]);

  const [sp3opt] = useState([
    "Right Arm Fast",
    "Right Arm Medium",
    "Left Arm Fast",
    "Left Arm Medium",
    "Off-Break",
    "Leg-Break",
    "Left Arm Orthodox",
    "Left Arm Chinaman",
  ]);

  const [joinauctionAid, setjoinauctionAid] = useState(
    () => getpageData?.response?.data?.detail?.aid || null
  );

  // Initialize state with values from props/context
  // const initialJoinAuctionAid =
  //   getpageData?.response?.data?.detail?.aid || null;

  // const [joinauctionAid, setjoinauctionAid] = useState(initialJoinAuctionAid);

  // const initialAuctionCode = getpageData?.response?.data?.detail?.acode || null;

  // const [auctionCode, setauctionCode] = useState(initialAuctionCode);

  const [auctionCode, setAuctionCode] = useState(() => {
    return getpageData?.response?.data?.detail?.acode || null;
  });

  const initialData = getpageData?.response?.data?.detail || {};
  const [data, setData] = useState(initialData);

  const [playingStyle, setPlayingStyle] = useState("");

  // Media query hooks must be at the top level
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  // History hook must be at the top level
  const history = useHistory({ forceRefresh: true });

  // Variables that don't need state
  let savenew = 0;
  let logo_pic = "";

  const auctionCodeSubmit = (values) => {
    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };
    DataService.JoinauctionCode(values, hdr)
      .then((res) => {
        let response = res.data;

        toast.dismiss(toastContainerId);

        dispatch(joinAuction({ response, values }));

        if (response.success == true) {
          if (response.data.detail.reg_player_on === "1") {
            localStorage.setItem("auction_id", response.data.detail.aid);

            toast.success("Now you can Join", {
              theme: "dark",
              position: "bottom-center",
            });
            fetchcatData(response.data.detail.aid);
            sethelpline(response.data.club);

            setData(response.data.detail);
            // history.push(BASE_PATH + "join-auction");
          }
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
      })
      .catch(() => {
        //  console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
  };
  const aid = localStorage.getItem("auction_id");

  const fetchcatData = async (aid) => {
    // setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listCategory({ aid: aid }, hdr)
      .then((res) => {
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;
          //  console.log(responsedata);
          setcatData(responsedata.list);
        }
        // setActive(false);
      })
      .catch(() => {
        //  console.log('Not valid')
        // setActive(false);
      });
  };
  const onSubmit = async (values) => {
    if (isSubmitting) return; // ❗Ultimate double-click protection
    setIsSubmitting(true);

    if (croppedImage == "" && defimg == playerdefaultLogo) {
      alert("Please add your profile picture !!");
      setIsSubmitting(false);
      setDisabled(false);
      return 0;
    }

    const formData = new FormData();

    // Add all regular form values to FormData
    Object.keys(values).forEach((key) => {
      if (key !== "receipt") {
        // Skip receipt since we'll handle it separately
        formData.append(key, values[key]);
      }
    });

    // Handle receipt file if it exists
    if (values.receipt && values.receipt[0]) {
      // Additional file size validation for security
      const file = values.receipt[0];
      const fileSizeInMB = file.size / (1024 * 1024);

      if (fileSizeInMB > 1) {
        toast.error("File size must be less than 1MB", {
          theme: "colored",
          position: "bottom-center",
        });
        setDisabled(false);
        return;
      }

      formData.append("receipt", file);
    }

    // Handle profile picture
    if (croppedImage === "") {
      formData.append("img", defimg2);
    }else if(savedFilename !== ""){
      formData.append("img", savedFilename);
    }
    else {
      try {
        // Step 1: Convert base64 to Blob → File
        const blob = await fetch(croppedImage).then((res) => res.blob());
        const fileName = `profile_${Date.now()}.jpg`;
        const file = new File([blob], fileName, {
          type: blob.type || "image/jpeg",
        });

        // Step 2: Get Presigned URL
        const urlForm = new FormData();
        urlForm.append("filename", file.name);
        urlForm.append("fltyp", "playerimg"); // match your backend

        const hdr = {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: JSON.stringify([
              { cid, aid, token: loginuser["token"] },
            ]),
          },
        };

        const getUrlRes = await ExternalDataService.getSignedUrl(urlForm, hdr);
        if (!getUrlRes.data.success) {
          throw new Error("Failed to get upload URL");
        }

        const { presignedUrl, filename } = getUrlRes.data.data;

        // Step 3: Upload to S3
        const uploadRes = await fetch(presignedUrl, {
          method: "PUT",
          headers: {
            "Content-Type": file.type,
            "x-amz-acl": "public-read",
          },
          body: file,
        });

        if (!uploadRes.ok) {
          const err = await uploadRes.text();
          throw new Error("Upload failed: " + err);
        }

        // Step 4: Only append filename to formData
        formData.append("img", filename);
        setSavedFilename(filename);

        toast.success("Profile picture uploaded!", { theme: "colored" });
      } catch (error) {
        console.error("Profile upload error:", error);
        toast.error(error.message || "Failed to upload profile picture");
        setDisabled(false);
        return;
      }
    }

    // Handle icons
    var icon = "";
    if (isbat == true) {
      if (icon == "") {
        icon += "bat.png";
      } else {
        icon += ",bat.png";
      }
    }
    if (isbol == true) {
      if (icon == "") {
        icon += "ball.png";
      } else {
        icon += ",ball.png";
      }
    }
    if (iswkeep == true) {
      if (icon == "") {
        icon += "gloves.png";
      } else {
        icon += ",gloves.png";
      }
    }
    formData.append("icons", icon);

    // Handle specification 3 for auction type 0
    if (auctype == 0) {
      formData.append("spcf3", sp3);
    }
    if (loginuser) {
      formData.append("pname", loginuser.cperson);
    }

    var hdr = {
      headers: {
        "Content-Type": "multipart/form-data", // Changed to multipart/form-data
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"], aid: joinauctionAid },
        ]),
      },
    };

    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });

    try {
      const res = await DataService.joinPlayer(formData, hdr);
      let response = res.data;
      toast.dismiss(toastContainerId);

      if (response.success == true) {
        let submitdata = [response.data.new];

        toast.success("Successfully Joined", {
          theme: "dark",
          position: "bottom-center",
        });
        localStorage.setItem("cjoined", data.auctionname);
        savenew ? reset() : history.push(`${BASE_PATH}join-auction-success`);
      } else {
        toast.error("Fields missing", { theme: "colored" });
      }
    } catch (error) {
      toast.dismiss(toastContainerId);
    
      console.error("JOIN PLAYER ERROR:", error);
    
      if (error.response) {
        console.error("Server response:", error.response.data);
        toast.error(error.response.data.msg || "Server Error");
      } else if (error.request) {
        toast.error("No response from server");
      } else {
        toast.error(error.message);
      }
    
      setIsSubmitting(false);
      setDisabled(false);
    } finally {
      setIsSubmitting(false);
      // setDisabled(false);
    }
  };

  useEffect(() => {
    const aid = localStorage.getItem("auction_id");
    localStorage.setItem("crp_typ", 0);
    fetchcatData(aid);
    //  console.log("get data  kya")
    //  console.log(getpageData)
    if (getpageData) {
      console.log("auctionCode");
      console.log(getpageData);
      console.log(auctionCode);
      setValue("acode", auctionCode);
      sethelpline(getpageData.response.data.club);
      setpyqr(getpageData.response.data.pyqr);
      setPaymentData(getpageData.response.data);
      setDate(getpageData.response.data.isaucdthide);
      // if (getpageData.response.data.profile.photo !== "") {
      //   setdefimg(getpageData.response.data.plpath + getpageData.response.data.profile.photo)
      // }
      // if(getpageData.response.data.detail.plprofile){
      //   setValue("fname", getpageData.response.data.detail.plprofile.fname!==null && getpageData.response.data.detail.plprofile.fname )
      // }
      if (getpageData.response.data.detail.already) {
        //  console.log(getpageData.response.data.plpath + getpageData.response.data.detail.already.photo)
        setdefimg(
          getpageData.response.data.plpath +
            getpageData.response.data.detail.already.photo
        );
        setdefimg2(getpageData.response.data.detail.already.photo);

        setValue(
          "age",
          getpageData.response.data.detail.already.age !== "0"
            ? getpageData.response.data.detail.already.age
            : ""
        );
        setValue("jrnm", getpageData.response.data.detail.already.jrnm);
        setValue("jrno", getpageData.response.data.detail.already.jrno);
        setValue("tshirt", getpageData.response.data.detail.already.tshirt);
        setValue("fname", getpageData.response.data.detail.already.fname);
        setValue("trouser", getpageData.response.data.detail.already.trouser);
        setValue("spcf3", getpageData.response.data.detail.already.belgaum);
        setValue("detail", getpageData.response.data.detail.already.detail);
        setValue("catid", getpageData.response.data.detail.already.isstarb);
        setValue("plst", getpageData.response.data.detail.already.isstarb);
        setValue("detail", getpageData.response.data.detail.already.detail);

        var runwkt = JSON.parse(
          getpageData.response.data.detail.already.runwkt
        );
        if (runwkt !== null && runwkt !== "") {
          if (runwkt.length > 0) {
            runwkt.forEach((ele, index) => {
              setValue("extra_" + index, ele.V);
            });
          }
        }

        if (getpageData.response.data.detail.already.icons != "") {
          var styles =
            getpageData.response.data.detail.already.icons.split(",");
          styles.forEach((ele) => {
            if (ele == "ball.png") {
              setisbol(true);
            } else if (ele == "bat.png") {
              setisbat(true);
            } else {
              setiswkeep(true);
            }
          });
        }

        const righthand = getpageData.response.data.detail.already.righthand;

        if (!sp1opt.includes(righthand)) {
          setOtherBatting(true);
          setValue("spcf1_other", righthand);
          setValue("spcf1", "Other");
        } else {
          setOtherBatting(false);
          setValue("spcf1", righthand);
        }
        const boller = getpageData.response.data.detail.already.boller;

        if (!sp2opt.includes(boller)) {
          setOtherBowling(true);
          setValue("spcf2_other", boller);
          setValue("spcf2", "Other");
        } else {
          setOtherBowling(false);
          setValue("spcf2", boller);
        }

        setcatid(getpageData.response.data.detail.already.isstarb);
      }
    } else {
      history.push(`${BASE_PATH}join-auction-code`);
    }
    // setdefimg()
    $(".crop-default img").attr("src", auctiondefaultLogo);

    $(".crop-default").click(function () {
      $("#crop-pic").click();
    });
  }, [getpageData, auctionCode, setValue, history]);

  var batstyle = {
    backgroundColor: "white",
  };
  var bolstyle = {
    backgroundColor: "white",
  };
  var wkeepstyle = {
    backgroundColor: "white",
  };
  if (isbat == true) {
    batstyle = {
      backgroundColor: "black",
      color: "white",
      border: "3px solid blue",
    };
  }
  if (isbol == true) {
    bolstyle = {
      backgroundColor: "black",
      color: "white",
      border: "3px solid blue",
    };
  }
  if (iswkeep == true) {
    wkeepstyle = {
      backgroundColor: "black",
      color: "white",
      border: "3px solid blue",
    };
  }
  return (
    <>
      <div>
        <Navigationtitle data={match} />
        <style>{fileUploadStyles}</style>

        {getpageData ? (
          <div
            id="top-categories"
            className="top-cat-area default-padding bottom-less"
          >
            <div className="container-fluid">
              <div className="row">
                <div id="contact-us" className="reg-area">
                  <div className="container-fluid">
                    <div
                      className="row joinheader"
                      style={{
                        backgroundColor: "rgb(248 248 251)",
                        margin: "20px 0px",
                        padding: "25px 6px",
                        borderRadius: "2px",
                      }}
                    >
                      <div className="item vertical">
                        <div className="info join-auction-form">
                          <div className="col-md-6 join-auction-info">
                            {data ? (
                              <div className="row onlyflex joinauc-flex">
                                <div className="col-md-2 join-auction-padding">
                                  <Image
                                    fallback={
                                      <Shimmer width={50} height={50} />
                                    }
                                    src={
                                      data && data.alogo != null
                                        ? auctiondefaultLogo
                                        : // getpageData.response.data.detail.path
                                          // .getpageData.response.data.detail
                                          // .alogo
                                          auctiondefaultLogo
                                    }
                                  ></Image>
                                </div>

                                <div className="col-md-10">
                                  <h5 className="joinauc-heading">
                                    {data.auctionname}{" "}
                                  </h5>
                                  {localStorage.getItem("auction_id") !==
                                    "51199" &&
                                    localStorage.getItem("auction_id") !==
                                      "56396" &&
                                    date !== "1" && (
                                      <p className="joinauc-date">
                                        Auction on : {data.dt}
                                      </p>
                                    )}
                                  <p className="helpline">
                                    Helpline No. :{" "}
                                    {paymentData &&
                                    paymentData.helpline_mob &&
                                    paymentData.helpline_mob.trim() !== ""
                                      ? paymentData.helpline_mob
                                      : helpline.mobno}{" "}
                                    ({" "}
                                    {paymentData &&
                                    paymentData.helpline_name &&
                                    paymentData.helpline_name.trim() !== ""
                                      ? paymentData.helpline_name
                                      : helpline.cperson}{" "}
                                    )
                                  </p>
                                  {data.info && (
                                      <div
                                        className="info-box"
                                        dangerouslySetInnerHTML={{ __html: data.info }}
                                      ></div>
                                    )}
                                  {localStorage.getItem("auction_id") ==
                                    38332 && (
                                    <p>Tournament dates : Feb 2nd 2025</p>
                                  )}
                                  {localStorage.getItem("auction_id") ==
                                    38332 && (
                                    <p>Ground : Skyline University, Sharjah</p>
                                  )}
                                  {localStorage.getItem("auction_id") ==
                                    38332 && (
                                    <p>
                                      Helpline No. : +97 1554880193, +97
                                      1527741732, +97 1555848783
                                    </p>
                                  )}

                                  {localStorage.getItem("auction_id") ==
                                    39141 && (
                                    <p style={{ lineHeight: "17px" }}>
                                      {" "}
                                      <b> Tournament Date</b> : 11-02-2025 ,
                                      Tuesday Morning
                                    </p>
                                  )}
                                  {localStorage.getItem("auction_id") ==
                                    39141 && (
                                    <p style={{ lineHeight: "17px" }}>
                                      {" "}
                                      <b> Important note</b> : Please make sure
                                      that you will be available for the
                                      tournament once you have registered. The
                                      selected players who are not playing in
                                      the tournament without valid reason will
                                      be banned from upcoming
                                      auction tournaments.
                                    </p>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          {isjoinanother && (
                            <div className="col-md-6 join-auction-info-form">
                              <div className="row">
                                <form
                                  onSubmit={handleSubmitCode(auctionCodeSubmit)}
                                  action=""
                                  autoComplete="off"
                                  encType="multipart/form-data"
                                >
                                  <div className="col-md-4">
                                    <div className="form-group">
                                      <input
                                        className="form-control"
                                        type="text"
                                        maxLength={9}
                                        minLength={8}
                                        placeholder="Enter A-Code"
                                        {...registerCode("acode", {
                                          required: true,
                                          required: "required field.",
                                        })}
                                      />
                                      {errorsCode.acode && (
                                        <p className="text-error">
                                          {errorsCode.acode.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>

                                  <div className="col-md-8 join-auction-padding">
                                    <div className="form-group">
                                      <button className="button" type="submit">
                                        {" "}
                                        SUBMIT
                                      </button>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          )}
                          {!isjoinanother && (
                            <button
                              onClick={() => setisjoinanother(!isjoinanother)}
                              className="joinanotherbtn"
                            >
                              Join Another
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="reg-items">
                        <div className="col-md-5  reg-form">
                          <form
                            onSubmit={handleSubmit(onSubmit)}
                            action=""
                            autoComplete="off"
                            encType="multipart/form-data"
                          >
                            <div className="row">
                              <div className="col-md-12">
                                <input
                                  {...register("acode")}
                                  type="hidden"
                                  defaultValue={auctionCode}
                                />
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin joinauc-margintop">
                                      <div className="col-md-4 margin-top-14px joinauc-profpic">
                                        <label
                                          htmlFor="crop-pic"
                                          className="joinauc-label"
                                        >
                                          {" "}
                                          Profile Pic{/*logo*/}{" "}
                                        </label>
                                      </div>
                                      <div className="col-md-8 margin-top-14px joinauc-margtop">
                                        {/* <Demo /> */}
                                        {localStorage.getItem("crp_typ") ==
                                        0 ? (
                                          <ImageCropper2
                                            croppedImage={croppedImage}
                                            defaultImage={defimg}
                                            setCroppedImage={setCroppedImage}
                                          />
                                        ) : (
                                          <ImageCropper1
                                            croppedImage={croppedImage}
                                            defaultimage={defimg}
                                            setCroppedImage={setCroppedImage}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="row onlyflex padd15">
                                      <div className="col-md-4">
                                        <div className="form-group text-box-margin joinauction-margb">
                                          <label className="joinauc-label">
                                            {" "}
                                            Name{" "}
                                          </label>
                                        </div>
                                      </div>
                                      <div className="col-md-8">
                                        <div className="form-group text-box-margin joinauction-margb">
                                          <label>
                                            {" "}
                                            {loginuser.cperson} (
                                            {loginuser.mobno})
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    {data.show.age.show == 1 && (
                                      <div className="row padd15">
                                        <div className="col-md-4">
                                          <div className="form-group text-box-margin nobottommar">
                                            <label className="joinauc-label">
                                              {" "}
                                              {data.show.age.label !== ""
                                                ? data.show.age.label
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  data.show.age.label.slice(1)
                                                : "Age"}
                                              {data.show.age.req == "1" && "*"}
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-md-8">
                                          <div className="form-group text-box-margin joinauction-margb">
                                            <input
                                              className="form-control joinaucinput-control"
                                              type="number"
                                              id="age"
                                              {...register("age", {
                                                required:
                                                  data.show.age.req == 1
                                                    ? "This is required"
                                                    : false,
                                              })}
                                            />
                                            {errors.age && (
                                              <p className="text-error">
                                                {errors.age.message}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {data.show.fname.show == 1 && (
                                      <div className="row padd15">
                                        <div className="col-md-4">
                                          <div className="form-group text-box-margin nobottommar">
                                            <label className="joinauc-label">
                                              {data.show.fname.label !== ""
                                                ? data.show.fname.label
                                                    .charAt(0)
                                                    .toUpperCase() +
                                                  data.show.fname.label.slice(1)
                                                : "Father's name"}
                                              {data.show.fname.req == "1" &&
                                                "*"}
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-md-8">
                                          <div className="form-group text-box-margin joinauction-margb">
                                            <input
                                              className="form-control joinaucinput-control"
                                              placeholder={
                                                data.show.fname.pholder ||
                                                "Father's Name"
                                              }
                                              type="text"
                                              id="age"
                                              {...register("fname", {
                                                required:
                                                  data.show.fname.req == 1
                                                    ? "This is required"
                                                    : false,
                                              })}
                                            />
                                            {errors.fname && (
                                              <p className="text-error">
                                                {errors.fname.message}
                                              </p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div className="form-group text-box-margin joinauction-margb">
                                    <label
                                      htmlFor="dob"
                                      className="joinauc-label"
                                    >
                                      {" "}
                                      Date of Birth
                                    </label>
                                    <input
                                      max={moment().format("YYYY-MM-DD")}
                                      className="form-control joinaucinput-control"
                                      type="date"
                                      id="dob"
                                      // {...register("dob", {
                                      //   required: true,
                                      //   required: "required field.",
                                      // })}
                                    />
                                    {errors.dob && (
                                      <p className="text-error">
                                        {errors.dob.message}
                                      </p>
                                    )}
                                  </div>
                                </div>

                                {data.show.tname.show == 1 && (
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin joinauction-margb">
                                      <label
                                        htmlFor="tshirt"
                                        className="joinauc-label"
                                      >
                                        {" "}
                                        {data.show.tname.label !== ""
                                          ? data.show.tname.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            data.show.tname.label.slice(1)
                                          : "Jersey Name"}
                                        {data.show.tname.req == "1" && "*"}
                                      </label>
                                      <input
                                        placeholder={
                                          data.show.tname.pholder ||
                                          "Jersey Name"
                                        }
                                        className="form-control joinaucinput-control"
                                        type="text"
                                        {...register("jrnm", {
                                          required:
                                            data.show.tname.req == 1
                                              ? "This is required"
                                              : false,
                                        })}
                                      />
                                      {errors.jrnm && (
                                        <p className="text-error">
                                          {errors.jrnm.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {data.show.tno.show == 1 && (
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin joinauction-margb">
                                      <label
                                        htmlFor="tshirt"
                                        className="joinauc-label"
                                      >
                                        {" "}
                                        {data.show.tno.label !== ""
                                          ? data.show.tno.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            data.show.tno.label.slice(1)
                                          : "Jersey Number"}
                                        {data.show.tno.req == "1" && "*"}
                                      </label>
                                      <input
                                        placeholder={
                                          data.show.tno.pholder ||
                                          "Jersey Number"
                                        }
                                        className="form-control joinaucinput-control"
                                        type="number"
                                        {...register("jrno", {
                                          required:
                                            data.show.tno.req == 1
                                              ? "This is required"
                                              : false,
                                          maxLength: {
                                            value: 10,
                                            message:
                                              "It must not exceed 10 characters.",
                                          },
                                        })}
                                      />
                                      {errors.jrno && (
                                        <p className="text-error">
                                          {errors.jrno.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {data.show.tshirt.show == 1 && (
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin joinauction-margb">
                                      <label
                                        htmlFor="tshirt"
                                        className="joinauc-label"
                                      >
                                        {" "}
                                        {data.show.tshirt.label !== ""
                                          ? data.show.tshirt.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            data.show.tshirt.label.slice(1)
                                          : "T-Shirt Size"}
                                        {data.show.tshirt.req == "1" && "*"}
                                      </label>
                                      <input
                                        className="form-control joinaucinput-control"
                                        type="text"
                                        placeholder={
                                          data.show.tshirt.pholder ||
                                          "S/M/L/XL/XXL/XXXL"
                                        }
                                        id="tshirt"
                                        {...register("tshirt", {
                                          required:
                                            data.show.tshirt.req == 1
                                              ? "This is required"
                                              : false,
                                        })}
                                      />

                                      {errors.tshirt && (
                                        <p className="text-error">
                                          {errors.tshirt.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}

                                {data.show.trouser.show == 1 && (
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin joinauction-margb">
                                      <label
                                        htmlFor="trouser"
                                        className="joinauc-label"
                                      >
                                        {" "}
                                        {data.show.trouser.label !== ""
                                          ? data.show.trouser.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            data.show.trouser.label.slice(1)
                                          : "Trouser"}
                                        {data.show.trouser.req == "1" && "*"}
                                      </label>
                                      <input
                                        className="form-control joinaucinput-control"
                                        id="trouser"
                                        placeholder={
                                          data.show.trouser.pholder ||
                                          "S/M/L/XL/XXL/XXXL"
                                        }
                                        type="text"
                                        {...register("trouser", {
                                          required:
                                            data.show.trouser.req == 1
                                              ? "This is required"
                                              : false,
                                          maxLength: {
                                            value: 10,
                                            message:
                                              "It must not exceed 10 characters.",
                                          },
                                        })}
                                      />
                                      {errors.trouser && (
                                        <p className="text-error">
                                          {errors.trouser.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {data.extra.length > 0 &&
                                  data.extra.map((item, index) => {
                                    if (item.o) {
                                      var dynamicoptions = item.o.split(",");
                                    }
                                    if (item.s == 0) return;
                                    return (
                                      <div className="col-md-6">
                                        <div className="form-group text-box-margin">
                                          {/* <label htmlFor="tshirt">
                                            {" "}
                                            {item.l}
                                            {item.r == "1" && "*"}
                                          </label> */}
                                          {item.t != "3" && (
                                            <label htmlFor="tshirt">
                                              {" "}
                                              {item.l}
                                              {item.r == "1" && "*"}
                                            </label>
                                          )}
                                          {item.t == "0" ? (
                                            <input
                                              placeholder={item.p || item.l}
                                              className="form-control"
                                              type="text"
                                              {...register("extra_" + index, {
                                                required:
                                                  item.r == 1
                                                    ? "This is required"
                                                    : false,
                                              })}
                                            />
                                          ) : item.t == "1" ? (
                                            <input
                                              placeholder={item.p || item.l}
                                              className="form-control"
                                              type="number"
                                              {...register("extra_" + index, {
                                                required:
                                                  item.r == 1
                                                    ? "This is required"
                                                    : false,
                                              })}
                                            />
                                          ) : item.t == "2" ? (
                                            <select
                                              className="form-control"
                                              id={item.label}
                                              type="text"
                                              {...register("extra_" + index, {
                                                required:
                                                  item.r == 1
                                                    ? "This is required"
                                                    : false,
                                              })}
                                            >
                                              <option value="">
                                                --select--
                                              </option>
                                              {dynamicoptions?.map(
                                                (el, ind) => {
                                                  return (
                                                    <option value={el}>
                                                      {el}
                                                    </option>
                                                  );
                                                }
                                              )}
                                            </select>
                                          ) : item.t == "3" ? (
                                            // MULTI CHECKBOX
                                            <div className="checkbox-multi-container">
                                              <label className="block text-sm font-medium text-gray-700 mb-1">
                                                {item.l}
                                                {item.r == 1 && <span className="text-red-500">*</span>}
                                              </label>

                                              <div className="checkbox-options-wrapper space-y-2">
                                                {dynamicoptions && dynamicoptions.length > 0 ? (
                                                  dynamicoptions.map((opt, optIndex) => (
                                                    <label
                                                      key={optIndex}
                                                      style={{ gap:"10px",
                                                        alignItems:'center',
                                                        height:"20px"
                                                      }}
                                                      className="flex items-center space-x-2 cursor-pointer"
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        value={opt}
                                                        {...register(`extra_${index}`, {
                                                          required:
                                                            item.r == 1
                                                              ? "Please select at least one option"
                                                              : false,
                                                        })}
                                                        className="h-4 w-4"
                                                      />
                                                      <span className="text-sm text-gray-700">{opt}</span>
                                                    </label>
                                                  ))
                                                ) : (
                                                  <p className="text-xs text-gray-500">No options configured</p>
                                                )}
                                              </div>

                                              {errors?.[`extra_${index}`] && (
                                                <p className="error-text text-red-500 text-xs mt-1 w-full">
                                                  {errors[`extra_${index}`].message}
                                                </p>
                                              )}
                                            </div>
                                          ) : item.t == "4" ? (
                                            <div className="file-input-container joinaucinput-control">
                                              <input
                                                type="file"
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                className="form-control addinput-control"
                                                // style={{ width: "510px" }}
                                                {...register(`extra_${index}`, {
                                                  required:
                                                    item.r == "1"
                                                      ? "Please upload a document"
                                                      : false,
                                                })}
                                              />
                                              {errors?.[`extra_${index}`] && (
                                                <p className="error-text text-red-500 text-xs mt-1">
                                                  {
                                                    errors[`extra_${index}`]
                                                      .message
                                                  }
                                                </p>
                                              )}
                                              <p className="text-xs text-gray-500 mt-1">
                                                Accepted: PDF, JPG, PNG (Max
                                                5MB)
                                              </p>
                                            </div>
                                          ) : item.t == "5" ? (
                                            <div className="form-group text-box-margin">
                                              {/* <label className="block text-sm font-medium text-gray-700 mb-1">
                                                    {item.l}
                                                    {item.r == "1" && (
                                                      <span className="text-red-500">
                                                        *
                                                      </span>
                                                    )}
                                                  </label> */}

                                              <input
                                                type="date"
                                                // min={moment().format(
                                                //   "YYYY-MM-DD"
                                                // )}
                                                className="form-control addinput-control"
                                                placeholder={
                                                  item.p || "Select date"
                                                }
                                                {...register(`extra_${index}`, {
                                                  required:
                                                    item.r == "1"
                                                      ? "This field is required"
                                                      : false,
                                                })}
                                              />

                                              {errors?.[`extra_${index}`] && (
                                                <p className="text-error text-red-500 text-xs mt-1">
                                                  {
                                                    errors[`extra_${index}`]
                                                      .message
                                                  }
                                                </p>
                                              )}
                                            </div>
                                          ) : (
                                            <select
                                              className="form-control"
                                              id={item.label}
                                              type="text"
                                              {...register("extra_" + index, {
                                                required:
                                                  item.r == 1
                                                    ? "This is required"
                                                    : false,
                                              })}
                                            >
                                              <option value="">
                                                --select--
                                              </option>
                                              {dynamicoptions?.map(
                                                (el, ind) => {
                                                  return (
                                                    <option value={el}>
                                                      {el}
                                                    </option>
                                                  );
                                                }
                                              )}
                                            </select>
                                          )}
                                          {errors.trouser && (
                                            <p className="text-error">
                                              {errors.trouser.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                {data.show.cat.show == 1 &&
                                  catData.length > 0 && (
                                    <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner no-side-padding">
                                      <label
                                        htmlFor="spcf1"
                                        className="joinauc-label"
                                      >
                                        {" "}
                                        {data.show.cat.label !== ""
                                          ? data.show.cat.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            data.show.cat.label.slice(1)
                                          : "Category"}{" "}
                                        {data.show.cat.req == "1" && "*"}{" "}
                                      </label>
                                      <select
                                        className="form-control spec-control"
                                        type="text"
                                        {...register("catid", {
                                          required:
                                            data.show.cat.req == 1
                                              ? "This is required"
                                              : false,
                                        })}
                                        value={catid}
                                        onChange={(e) => {
                                          setcatid(e.target.value);
                                        }}
                                      >
                                        <option value="" selected>
                                          Select{" "}
                                          {data.show.cat.label !== ""
                                            ? data.show.cat.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.cat.label.slice(1)
                                            : "Category"}
                                        </option>
                                        {catData?.map((ct) => (
                                          <option value={ct.cid} key={ct.cid}>
                                            {ct.cname}
                                          </option>
                                        ))}
                                      </select>
                                      {errors.catid && (
                                        <p className="text-error">
                                          {errors.catid.message}
                                        </p>
                                      )}
                                    </div>
                                  )}
                                {data.show.icon.show == 1 && auctype == "0" && (
                                  <div className="col-md-12 martop joinauc-margtop">
                                    <div className="row">
                                      <div className="col-md-2 margin-top-14px joinauc-margtop">
                                        <label
                                          htmlFor=""
                                          className="joinauc-label"
                                        >
                                          {" "}
                                          {data.show.icon.label !== ""
                                            ? data.show.icon.label
                                                .charAt(0)
                                                .toUpperCase() +
                                              data.show.icon.label.slice(1)
                                            : "Playing style"}
                                          {data.show.icon.req == "1" && "*"}
                                        </label>
                                      </div>
                                      <div className="col-md-8 ">
                                        <div
                                          className={`roleclass form-group text-box-margin joinauction-margb ${
                                            isTabletOrMobile || isPortrait
                                              ? "row"
                                              : null
                                          }`}
                                        >
                                          <div className="">
                                            <img
                                              onClick={() => setisbat(!isbat)}
                                              src={bat}
                                              alt=""
                                              style={batstyle}
                                            />
                                          </div>
                                          <div className="">
                                            <img
                                              onClick={() => setisbol(!isbol)}
                                              src={ball}
                                              alt=""
                                              style={bolstyle}
                                            />
                                          </div>
                                          <div className="">
                                            <img
                                              onClick={() =>
                                                setiswkeep(!iswkeep)
                                              }
                                              src={wkeeper}
                                              alt=""
                                              style={wkeepstyle}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}

                                <div className="col-md-12 margin-top-14px joinauc-margtop">
                                  <div className="row">
                                    <div className="col-md-6 no-side-padd no-side-padd-lap">
                                      {data && data.show.sp1.show == 1 && (
                                        <div className="row">
                                          <div className="form-group text-box-margin joinauction-margb">
                                            <div className="col-md-4 no-side-padd no-side-padd-lap">
                                              <label
                                                htmlFor="spcf1"
                                                className="joinauc-label"
                                              >
                                                {" "}
                                                {data.show.sp1.label !== ""
                                                  ? data.show.sp1.label
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    data.show.sp1.label.slice(1)
                                                  : "Specification 1"}
                                                {data.show.sp1.req == "1" &&
                                                  "*"}{" "}
                                              </label>
                                            </div>
                                            {auctype != 0 ? (
                                              <div className="col-md-8 no-side-padd">
                                                {" "}
                                                <input
                                                  placeholder={
                                                    data.show.sp1.pholder ||
                                                    "Specification 1"
                                                  }
                                                  className="form-control spec-control"
                                                  type="text"
                                                  {...register("spcf1", {})}
                                                />
                                              </div>
                                            ) : data.show.sp1.opt == "" ||
                                              data.show.sp1.opt == null ? (
                                              <div className="col-md-6 no-side-padd no-side-padd-lap">
                                                {/* jjjjjj */}

                                                <select
                                                  className="form-control spec-control"
                                                  id="spcf1"
                                                  type="text"
                                                  {...register("spcf1", {
                                                    required:
                                                      data.show.sp1.req == 1
                                                        ? "This is required"
                                                        : false,
                                                  })}
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.value === "Other"
                                                    ) {
                                                      setOtherBatting(true);
                                                    } else {
                                                      setOtherBatting(false);
                                                    }
                                                    setBatting(e.target.value);
                                                  }}
                                                >
                                                  <option value={""}>
                                                    --select--
                                                  </option>
                                                  {sp1opt.map((ele) => (
                                                    <option value={ele}>
                                                      {ele}
                                                    </option>
                                                  ))}
                                                </select>
                                                {errors.spcf1 && (
                                                  <p className="text-error">
                                                    {errors.spcf1.message}
                                                  </p>
                                                )}
                                              </div>
                                            ) : (
                                              <div className="col-md-6 no-side-padd no-side-padd-lap">
                                                {/* kkkkk */}
                                                <select
                                                  className="form-control"
                                                  id="spcf1"
                                                  type="text"
                                                  {...register("spcf1", {
                                                    required:
                                                      data.show.sp1.req == 1
                                                        ? "This is required"
                                                        : false,
                                                  })}
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.value === "Other"
                                                    ) {
                                                      setOtherBatting(true);
                                                    } else {
                                                      setOtherBatting(false);
                                                    }
                                                    setBatting(e.target.value);
                                                  }}
                                                >
                                                  <option value={""}>
                                                    --select--
                                                  </option>
                                                  {data?.show?.sp1?.opt
                                                    ?.split(",")
                                                    .map((ele) => (
                                                      <option value={ele}>
                                                        {ele}
                                                      </option>
                                                    ))}
                                                </select>
                                                {errors.spcf1 && (
                                                  <p className="text-error">
                                                    {errors.spcf1.message}
                                                  </p>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    {otherBatting ? (
                                      <div className="col-md-6">
                                        <div className="row form-group text-box-margin">
                                          <div className="col-md-4">
                                            <label htmlFor="spcf2">
                                              {" "}
                                              Other{" "}
                                            </label>
                                          </div>
                                          <div className="col-md-8">
                                            <input
                                              placeholder="Other"
                                              className="form-control"
                                              type="text"
                                              {...register("spcf1_other")}
                                              onChange={(e) =>
                                                setBatting(e.target.value)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>

                                <div className="col-md-12 margin-top-14px joinauc-margtop">
                                  {data.show.sp2.show == 1 && (
                                    <div className="row">
                                      <div className="col-md-6 no-side-padd no-side-padd-lap">
                                        <div className="row">
                                          <div className="form-group text-box-margin joinauction-margb">
                                            <div className="col-md-4 no-side-padd no-side-padd-lap">
                                              <label
                                                htmlFor="spcf2"
                                                className="joinauc-label"
                                              >
                                                {" "}
                                                {data.show.sp2.label !== ""
                                                  ? data.show.sp2.label
                                                      .charAt(0)
                                                      .toUpperCase() +
                                                    data.show.sp2.label.slice(1)
                                                  : "Specification 2"}
                                                {data.show.sp2.req == "1" &&
                                                  "*"}{" "}
                                              </label>
                                            </div>
                                            {auctype != 0 ? (
                                              <div className="col-md-8 no-side-padd">
                                                {" "}
                                                <input
                                                  placeholder={
                                                    data.show.sp2.pholder ||
                                                    "Specification 2"
                                                  }
                                                  className="form-control spec-control"
                                                  type="text"
                                                  {...register("spcf2", {})}
                                                />
                                              </div>
                                            ) : data.show.sp2.opt == "" ||
                                              data.show.sp2.opt == null ? (
                                              <div className="col-md-6 no-side-padd no-side-padd-lap">
                                                {" "}
                                                <select
                                                  className="form-control spec-control"
                                                  id="spcf2"
                                                  type="text"
                                                  {...register("spcf2", {
                                                    required:
                                                      data.show.sp2.req == 1
                                                        ? "This is required"
                                                        : false,
                                                  })}
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.value === "Other"
                                                    ) {
                                                      setOtherBowling(true);
                                                    } else {
                                                      setOtherBowling(false);
                                                    }
                                                    setBowling(e.target.value);
                                                  }}
                                                >
                                                  <option value={""}>
                                                    --select--
                                                  </option>
                                                  {batting ==
                                                    "Bowling All Rounder" ||
                                                  batting == "Bowler"
                                                    ? sp3opt.map((ele) => (
                                                        <option value={ele}>
                                                          {ele}
                                                        </option>
                                                      ))
                                                    : sp2opt.map((ele) => (
                                                        <option value={ele}>
                                                          {ele}
                                                        </option>
                                                      ))}
                                                  <option value="Other">
                                                    Other
                                                  </option>
                                                </select>
                                                {errors.spcf2 && (
                                                  <p className="text-error">
                                                    {errors.spcf2.message}
                                                  </p>
                                                )}
                                              </div>
                                            ) : (
                                              <div className="col-md-6 no-side-padd no-side-padd-lap">
                                                {" "}
                                                <select
                                                  className="form-control"
                                                  id="spcf2"
                                                  type="text"
                                                  {...register("spcf2", {
                                                    required:
                                                      data.show.sp2.req == 1
                                                        ? "This is required"
                                                        : false,
                                                  })}
                                                  onChange={(e) => {
                                                    if (
                                                      e.target.value === "Other"
                                                    ) {
                                                      setOtherBowling(true);
                                                    } else {
                                                      setOtherBowling(false);
                                                    }
                                                    setBowling(e.target.value);
                                                  }}
                                                >
                                                  <option value={""}>
                                                    --select--
                                                  </option>
                                                  {batting ==
                                                    "Bowling All Rounder" ||
                                                  batting == "Bowler"
                                                    ? data?.show?.sp3.opt == ""
                                                      ? sp3opt.map((ele) => (
                                                          <option value={ele}>
                                                            {ele}
                                                          </option>
                                                        ))
                                                      : data?.show?.sp3?.opt
                                                          ?.split(",")
                                                          .map((ele) => (
                                                            <option value={ele}>
                                                              {ele}
                                                            </option>
                                                          ))
                                                    : data?.show?.sp2?.opt == ""
                                                    ? sp2opt.map((ele) => (
                                                        <option value={ele}>
                                                          {ele}
                                                        </option>
                                                      ))
                                                    : data?.show?.sp2?.opt
                                                        ?.split(",")
                                                        .map((ele) => (
                                                          <option value={ele}>
                                                            {ele}
                                                          </option>
                                                        ))}
                                                  <option value="Other">
                                                    Other
                                                  </option>
                                                </select>
                                                {errors.spcf2 && (
                                                  <p className="text-error">
                                                    {errors.spcf2.message}
                                                  </p>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      {otherBowling ? (
                                        <div className="col-md-6">
                                          <div className="row form-group text-box-margin">
                                            <div className="col-md-4">
                                              <label htmlFor="spcf2">
                                                {" "}
                                                Other{" "}
                                              </label>
                                            </div>
                                            <div className="col-md-8">
                                              <input
                                                placeholder="Other"
                                                className="form-control"
                                                // {...register("spcf2")}
                                                type="text"
                                                {...register("spcf2_other")}
                                                onChange={(e) =>
                                                  setBowling(e.target.value)
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  )}
                                </div>
                                {data.show.sp3.show == 1 && (
                                  <div className="row">
                                    <div className="col-md-6 margin-top-14px joinauc-margtop no-side-padd no-side-padd-lap">
                                      <div className="form-group text-box-margin joinauction-margb">
                                        <div className="col-md-4 no-side-padd">
                                          <label
                                            htmlFor="spcf1"
                                            className="joinauc-label"
                                          >
                                            {" "}
                                            {data.show.sp3.label !== ""
                                              ? data.show.sp3.label
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                data.show.sp3.label.slice(1)
                                              : "Specification 3"}
                                            {data.show.sp3.req == "1" && "*"}{" "}
                                          </label>
                                        </div>
                                        {auctype != 0 ? (
                                          <div className="col-md-8 no-side-padd">
                                            {" "}
                                            <input
                                              placeholder={
                                                data.show.sp3.pholder ||
                                                "Specification 3"
                                              }
                                              className="form-control spec-control"
                                              type="text"
                                              {...register("spcf3", {})}
                                            />
                                          </div>
                                        ) : data.show.sp3.opt == "" ||
                                          data.show.sp3.opt == null ? (
                                          <div className="col-md-6 no-side-padd">
                                            {" "}
                                            <select
                                              className="form-control spec-control"
                                              id="spcf3"
                                              type="text"
                                              {...register("spcf3", {
                                                required: false,
                                                // required: "required field.",
                                              })}
                                              onChange={(e) => {
                                                if (
                                                  e.target.value === "Other"
                                                ) {
                                                  setOthersp3(true);
                                                } else {
                                                  setOthersp3(false);
                                                }
                                                setsp3(e.target.value);
                                              }}
                                            >
                                              <option value={""}>
                                                --Specification 3--
                                              </option>
                                              {batting ==
                                                "Bowling All Rounder" ||
                                              batting == "Bowler"
                                                ? sp2opt.map((ele) => (
                                                    <option value={ele}>
                                                      {ele}
                                                    </option>
                                                  ))
                                                : sp3opt.map((ele) => (
                                                    <option value={ele}>
                                                      {ele}
                                                    </option>
                                                  ))}

                                              <option value="Other">
                                                Other
                                              </option>
                                            </select>
                                            {errors.spcf2 && (
                                              <p className="text-error">
                                                {errors.spcf2.message}
                                              </p>
                                            )}
                                          </div>
                                        ) : (
                                          <div className="col-md-6 no-side-padd">
                                            {" "}
                                            <select
                                              className="form-control"
                                              id="spcf3"
                                              type="text"
                                              {...register("spcf3", {
                                                required: false,
                                                // required: "required field.",
                                              })}
                                              onChange={(e) => {
                                                if (
                                                  e.target.value === "Other"
                                                ) {
                                                  setOthersp3(true);
                                                } else {
                                                  setOthersp3(false);
                                                }
                                                setsp3(e.target.value);
                                              }}
                                            >
                                              <option value={""}>
                                                --Specification 3--
                                              </option>
                                              {batting ==
                                                "Bowling All Rounder" ||
                                              batting == "Bowler"
                                                ? data?.show?.sp2.opt == ""
                                                  ? sp2opt.map((ele) => (
                                                      <option value={ele}>
                                                        {ele}
                                                      </option>
                                                    ))
                                                  : data?.show?.sp2?.opt
                                                      ?.split(",")
                                                      .map((ele) => (
                                                        <option value={ele}>
                                                          {ele}
                                                        </option>
                                                      ))
                                                : data?.show?.sp3?.opt == ""
                                                ? sp3opt.map((ele) => (
                                                    <option value={ele}>
                                                      {ele}
                                                    </option>
                                                  ))
                                                : data?.show?.sp3?.opt
                                                    ?.split(",")
                                                    .map((ele) => (
                                                      <option value={ele}>
                                                        {ele}
                                                      </option>
                                                    ))}

                                              <option value="Other">
                                                Other
                                              </option>
                                            </select>
                                            {errors.spcf2 && (
                                              <p className="text-error">
                                                {errors.spcf2.message}
                                              </p>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    {othersp3 ? (
                                      <div className="col-md-6">
                                        <div className="row form-group text-box-margin">
                                          <div className="col-md-4">
                                            <label htmlFor="spcf2">
                                              {" "}
                                              Other{" "}
                                            </label>
                                          </div>
                                          <div className="col-md-8">
                                            <input
                                              placeholder="Other"
                                              className="form-control"
                                              type="text"
                                              {...register("spcf3_other")}
                                              onChange={(e) =>
                                                setsp3(e.target.value)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )}
                                {data.show.detail.show == 1 && (
                                  <div className="col-md-12">
                                    <div className="form-group text-box-margin joinauction-margb">
                                      <label
                                        htmlFor="detail"
                                        className="joinauc-label"
                                      >
                                        {" "}
                                        {data.show.detail.label !== ""
                                          ? data.show.detail.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            data.show.detail.label.slice(1)
                                          : "Detail"}
                                        {data.show.detail.req == "1" && "*"}{" "}
                                      </label>
                                      <textarea
                                        placeholder={
                                          data.show.detail.pholder || "Detail"
                                        }
                                        className="form-control joinaucdetail-control"
                                        id="other_details"
                                        {...register("detail", {
                                          required:
                                            data.show.detail.req == 1
                                              ? "This is required"
                                              : false,
                                        })}
                                      ></textarea>
                                    </div>
                                  </div>
                                )}
                                {paymentData &&
                                  paymentData.show_payment == "1" && (
                                    <div className="col-md-12">
                                      <div className="form-group text-box-margin">
                                        <QRContainer>
                                          {/* Show QR Image only for UPI payments */}
                                          {paymentData &&
                                            paymentData.payment_method ===
                                              "upi" &&
                                            (pyqr.mob || pyqr.qr) && (
                                              <QRImageWrapper>
                                                <QRImage
                                                  src={
                                                    pyqr.qr
                                                      ? `${pyqr.path}${pyqr.qr}`
                                                      : data &&
                                                        data.alogo != null
                                                      ? data.alogo
                                                      : auctiondefaultLogo
                                                  }
                                                  alt="Payment QR Code"
                                                />
                                              </QRImageWrapper>
                                            )}

                                          <QRDetailsWrapper>
                                            {/* Bank Payment Details */}
                                            {paymentData &&
                                              paymentData.payment_method ===
                                                "bank" &&
                                              paymentData.bankdt && (
                                                <>
                                                  <QRSectionTitle>
                                                    Please transfer Registration
                                                    fee{" "}
                                                    <span
                                                      style={{
                                                        fontSize: "1.4rem",
                                                        fontWeight: "bold",
                                                        color: "#689F38",
                                                      }}
                                                    >
                                                      ₹{paymentData.bankdt.fees}
                                                    </span>{" "}
                                                    to the following account
                                                  </QRSectionTitle>
                                                  <QRDetailRow>
                                                    <QRDetailLabel>
                                                      Bank Name:
                                                    </QRDetailLabel>
                                                    <QRDetailValue>
                                                      {
                                                        paymentData.bankdt
                                                          .bank_name
                                                      }
                                                    </QRDetailValue>
                                                  </QRDetailRow>

                                                  <QRDetailRow>
                                                    <QRDetailLabel>
                                                      Account Number:
                                                    </QRDetailLabel>
                                                    <QRDetailValue className="flex items-center gap-2 font-mono">
                                                      {
                                                        paymentData.bankdt
                                                          .bank_acc
                                                      }
                                                      <div>
                                                        <button
                                                          onClick={() =>
                                                            formlinkcopy3(
                                                              paymentData.bankdt
                                                                .bank_acc
                                                            )
                                                          }
                                                          className="copy-btn"
                                                        >
                                                          {iscopied3 ? (
                                                            <Check className="w-3 h-3" />
                                                          ) : (
                                                            <Copy className="w-3 h-3" />
                                                          )}
                                                        </button>
                                                      </div>
                                                    </QRDetailValue>
                                                  </QRDetailRow>

                                                  <QRDetailRow>
                                                    <QRDetailLabel>
                                                      IFSC Code:
                                                    </QRDetailLabel>
                                                    <QRDetailValue className="flex items-center gap-2 font-mono">
                                                      {
                                                        paymentData.bankdt
                                                          .bank_ifsc
                                                      }
                                                      <div>
                                                        <button
                                                          onClick={() =>
                                                            formlinkcopy4(
                                                              paymentData.bankdt
                                                                .bank_ifsc
                                                            )
                                                          }
                                                          className="copy-btn"
                                                        >
                                                          {iscopied4 ? (
                                                            <Check className="w-3 h-3" />
                                                          ) : (
                                                            <Copy className="w-3 h-3" />
                                                          )}
                                                        </button>
                                                      </div>
                                                    </QRDetailValue>
                                                  </QRDetailRow>

                                                  <QRDetailRow>
                                                    <QRDetailLabel>
                                                      Registration Fees:
                                                    </QRDetailLabel>
                                                    <QRDetailValue
                                                      style={{
                                                        fontSize: "1.4rem",
                                                        fontWeight: "bold",
                                                        color: "#689F38",
                                                      }}
                                                    >
                                                      ₹{paymentData.bankdt.fees}
                                                    </QRDetailValue>
                                                  </QRDetailRow>

                                                  <QRInstructions>
                                                    Please transfer the
                                                    registration fee to the
                                                    above bank account and
                                                    upload the receipt.
                                                  </QRInstructions>
                                                </>
                                              )}

                                            {/* UPI Payment Details */}
                                            {paymentData &&
                                              paymentData.payment_method ===
                                                "upi" &&
                                              (pyqr.mob || pyqr.qr) && (
                                                <>
                                                  <QRSectionTitle>
                                                    Payment Details
                                                  </QRSectionTitle>
                                                  <QRDetailRow>
                                                    <QRDetailLabel>
                                                      Name:
                                                    </QRDetailLabel>
                                                    <QRDetailValue>
                                                      {pyqr.name}
                                                    </QRDetailValue>
                                                  </QRDetailRow>

                                                  <QRDetailRow>
                                                    <QRDetailLabel>
                                                      UPI No.:
                                                    </QRDetailLabel>
                                                    <QRDetailValue>
                                                      {pyqr.mob}
                                                    </QRDetailValue>
                                                  </QRDetailRow>

                                                  <QRDetailRow>
                                                    <QRDetailLabel>
                                                      Fees:
                                                    </QRDetailLabel>
                                                    <QRFeeValue>
                                                      ₹{pyqr.fee}
                                                    </QRFeeValue>
                                                  </QRDetailRow>

                                                  <QRInstructions>
                                                    Please scan the QR code to
                                                    make the payment and upload
                                                    the receipt.
                                                  </QRInstructions>
                                                </>
                                              )}

                                            {/* Special case for auction_id 54158 */}
                                            {localStorage.getItem(
                                              "auction_id"
                                            ) == 54158 && (
                                              <>
                                                <QRSectionTitle>
                                                  Please transfer Registration
                                                  fee{" "}
                                                  <span
                                                    style={{
                                                      fontSize: "1.4rem",
                                                      fontWeight: "bold",
                                                      color: "#689F38",
                                                    }}
                                                  >
                                                    £15{" "}
                                                  </span>{" "}
                                                  to the following account{" "}
                                                </QRSectionTitle>
                                                <QRDetailRow>
                                                  <QRDetailLabel>
                                                    Beneficiary:
                                                  </QRDetailLabel>
                                                  <QRDetailValue>
                                                    MANDHI SOUQ LTD
                                                  </QRDetailValue>
                                                </QRDetailRow>

                                                <QRDetailRow>
                                                  <QRDetailLabel>
                                                    Sort code:
                                                  </QRDetailLabel>
                                                  <QRDetailValue>
                                                    043606
                                                  </QRDetailValue>
                                                </QRDetailRow>

                                                <QRDetailRow>
                                                  <QRDetailLabel width="auto">
                                                    Account number:
                                                  </QRDetailLabel>
                                                  <QRDetailValue>
                                                    00190306
                                                  </QRDetailValue>
                                                </QRDetailRow>
                                                <QRDetailRow>
                                                  <QRDetailLabel width="auto">
                                                    Registration Fees:
                                                  </QRDetailLabel>
                                                  <QRDetailValue
                                                    style={{
                                                      fontSize: "1.4rem",
                                                      fontWeight: "bold",
                                                      color: "#689F38",
                                                    }}
                                                  >
                                                    £15
                                                  </QRDetailValue>
                                                </QRDetailRow>
                                                <QRDetailRow>
                                                  <QRDetailLabel>
                                                    Ref:
                                                  </QRDetailLabel>
                                                  <QRDetailValue>
                                                    Player Name
                                                  </QRDetailValue>
                                                </QRDetailRow>
                                              </>
                                            )}
                                            {localStorage.getItem("auction_id") == 56529 && (
                                                  <>
                                                    <QRSectionTitle>
                                                      Please transfer Registration fee{" "}
                                                      <span
                                                        style={{
                                                          fontSize: "1.4rem",
                                                          fontWeight: "bold",
                                                          color: "#689F38",
                                                        }}
                                                      >

                                                      </span>{" "}
                                                      to the following account
                                                    </QRSectionTitle>

                                                    {pyqr.pydetail && (
                                                      <div
                                                        style={{
                                                          marginTop: "10px",
                                                          whiteSpace: "pre-line",
                                                          fontSize: "14px",
                                                          color: "#444",
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: pyqr.pydetail }}
                                                      ></div>
                                                    )}
                                                  </>
                                                )}
                                          </QRDetailsWrapper>
                                        </QRContainer>
                                      </div>
                                    </div>
                                  )}

                                {data && data.show.receipt.show == 1 && (
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin receipt-box ">
                                      <label
                                        htmlFor="reciept"
                                        className="receipt-label joinauc-label"
                                      >
                                        {data.show.receipt.label !== ""
                                          ? data.show.receipt.label
                                              .charAt(0)
                                              .toUpperCase() +
                                            data.show.receipt.label.slice(1)
                                          : "Receipt"}
                                        {data.show.receipt.req == "1" && (
                                          <span className="required-asterisk">
                                            *
                                          </span>
                                        )}
                                      </label>
                                      <div
                                        className="file-upload-container"
                                        style={
                                          selectedReceiptFile
                                            ? {
                                                borderColor: "#2e7d32",
                                                backgroundColor: "#e8f5e9",
                                              }
                                            : {}
                                        }
                                      >
                                        <div className="upload-icon">
                                          <AiIcons.AiOutlineCloudUpload
                                            size={30}
                                          />
                                        </div>

                                        {selectedReceiptFile ? (
                                          <div className="file-preview">
                                            <p className="file-name">
                                              {selectedReceiptFile.name}
                                            </p>
                                            {selectedReceiptFile.type.startsWith(
                                              "image/"
                                            ) && (
                                              <img
                                                src={URL.createObjectURL(
                                                  selectedReceiptFile
                                                )}
                                                alt="Receipt preview"
                                                style={{
                                                  maxWidth: "100%",
                                                  maxHeight: "100px",
                                                  marginTop: "10px",
                                                  borderRadius: "4px",
                                                  boxShadow:
                                                    "0 2px 5px rgba(0,0,0,0.1)",
                                                }}
                                              />
                                            )}
                                          </div>
                                        ) : (
                                          <p className="upload-text">
                                            Drag & drop or click to select file
                                          </p>
                                        )}

                                        <input
                                          id="receipt-file-input"
                                          placeholder={
                                            data.show.receipt.pholder ||
                                            "Receipt"
                                          }
                                          className="file-input"
                                          type="file"
                                          accept="image/*"
                                          {...register("receipt", {
                                            required:
                                              data.show.receipt.req == 1
                                                ? "This is required"
                                                : false,
                                            onChange: (e) => {
                                              if (
                                                e.target.files &&
                                                e.target.files[0]
                                              ) {
                                                const file = e.target.files[0];
                                                const fileSizeInMB =
                                                  file.size / (1024 * 1024);

                                                if (fileSizeInMB > 1) {
                                                  toast.error(
                                                    "File size must be less than 1MB",
                                                    {
                                                      theme: "colored",
                                                      position: "bottom-center",
                                                    }
                                                  );
                                                  e.target.value = "";
                                                  setSelectedReceiptFile(null);
                                                  return;
                                                }

                                                setSelectedReceiptFile(file);
                                              } else {
                                                setSelectedReceiptFile(null);
                                              }
                                            },
                                          })}
                                        />
                                        <p className="file-size-limit">
                                          Maximum file size: 1MB
                                        </p>
                                      </div>
                                      {errors.receipt && (
                                        <p className="error-message">
                                          {errors.receipt.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )}

                                {data && data.show.receipt.show == 1 && (
                                  <div className="col-md-12 receipt-message-div">
                                    <div className="receipt-message">
                                      {data.show.receipt.pholder !== ""
                                        ? data.show.receipt.pholder
                                        : ""}
                                    </div>
                                  </div>
                                )}

                                {localStorage.getItem("auction_id") ==
                                  38524 && (
                                  <div className="qr-container col-md-6">
                                    <img src={qr1} alt="" />
                                    <p>
                                      <b>Registration fees : 800/-</b>
                                    </p>
                                  </div>
                                )}

                                <div className="col-md-12">
                                  <p className="checkbox-margin">
                                    <input
                                      type="checkbox"
                                      required
                                      style={{
                                        "min-height": "20px",
                                        "margin-right": "10px",
                                      }}
                                    />
                                    Yes , I want to join
                                  </p>

                                  <button
                                    className="button joinauc-margtop joinaucbtn-pad"
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                      width: "100%",
                                      opacity: isSubmitting ? 0.7 : 1,
                                      pointerEvents: isSubmitting
                                        ? "none"
                                        : "auto",
                                    }}
                                  >
                                    {isSubmitting
                                      ? "Joining..."
                                      : "Join Auction"}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <NotFound data={""} />
        )}
      </div>
    </>
  );
}

export default JoinAuctionPage;
